import { chakra, Box, Flex } from '@chakra-ui/react';
import { EThemes } from '@/constants/themeConfig';

export const BannerContainer = chakra(Box, {
  baseStyle: ({ theme }) => ({
    label: 'toteChangesBanner-BannerContainer',
    bg: 'blue.50',
    border: '1px solid',
    borderColor: 'blue.200',
    borderRadius: 'md',
    color: 'blue.900',
    px: '4',
    py: '3',
    mb: '3',
    fontSize: 'sm',
    ...(theme.themeName === EThemes.Juicybet && {
      mx: '3',
    }),
  }),
});

export const BannerHeader = chakra(Flex, {
  baseStyle: () => ({
    label: 'toteChangesBanner-BannerHeader',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    fontWeight: 'bold',
    gap: '2',
  }),
});

export const BannerHeaderLeft = chakra(Flex, {
  baseStyle: () => ({
    label: 'toteChangesBanner-BannerHeaderLeft',
    alignItems: 'center',
    gap: '2',
  }),
});

export const BannerBody = chakra(Box, {
  baseStyle: () => ({
    label: 'toteChangesBanner-BannerBody',
    mt: '2',
    lineHeight: '1.4',
    fontWeight: 'normal',
  }),
});
